import Sortable from 'js/vendor/sortable.min'
import { CLOSE_BUTTON_SELECTOR } from 'components/modal/component'
import { openCloudinaryWidget, isCloudinaryWidgetOpen, preloadCloudinaryWidget } from 'js/lib/cloudinary'
import { on } from 'js/lib/events'

initialize()

async function initialize() {
  if (!$('.c-listing-photo-uploader').length) return

  preloadCloudinaryWidget()

  let photoUploadCount = $('.js-c-listing-photo-uploader__thumbnail').length
  let videoUploadCount = $('.js-c-listing-video-uploader__thumbnail').length
  let photoUploadButton = $('#js-c-listing-photo-uploader__button')
  let videoUploadButton = $('#js-c-listing-video-uploader__button')
  const MAX_IMAGES = 9
  const MAX_VIDEOS = 4

  on(
    'click',
    '#js-c-listing-photo-uploader__button, .js-c-listing-photo-uploader-placeholder',
    async function () {
      if (isCloudinaryWidgetOpen()) return

      var results = await openCloudinaryWidget({
        thumbnailTransformation: { width: 80, height: 80, crop: 'fill' },
        maxImageWidth: 2000,
        maxImageHeight: 2000,
        resourceType: 'image',
        sources: ['local', 'url', 'camera', 'dropbox', 'facebook', 'instagram', 'google_drive'],
        maxFiles: MAX_IMAGES - photoUploadCount,
        tags: ['listing_photo'],
      })

      results.forEach(function (result) {
        uploadAndDisplay(result.info)
      })
    },
    false
  )

  on(
    'click',
    '#js-c-listing-video-uploader__button, .js-c-listing-video-uploader-placeholder',
    async function () {
      if (isCloudinaryWidgetOpen()) return

      var results = await openCloudinaryWidget({
        thumbnailTransformation: { width: 80, height: 80, crop: 'fill' },
        maxImageWidth: 2000,
        maxImageHeight: 2000,
        resourceType: 'video',
        sources: ['local', 'url', 'camera', 'dropbox', 'facebook', 'instagram', 'google_drive'],
        maxFiles: MAX_VIDEOS - videoUploadCount,
        tags: ['listing_video'],
      })

      results.forEach(function (result) {
        uploadAndDisplay(result.info)
      })
    },
    false
  )

  updatePhotoUIState(photoUploadCount)
  updateVideoUIState(videoUploadCount)

  function updatePhotoUIState(photoUploadCount) {
    $('.js-c-listing-photo-uploader__limit-count').text(photoUploadCount)
    if (MAX_IMAGES - photoUploadCount <= 0) {
      photoUploadButton.prop('disabled', true)
      photoUploadButton.addClass('disabled')
    }
  }

  function updateVideoUIState(videoUploadCount) {
    $('.js-c-listing-video-uploader__limit-count').text(videoUploadCount)
    if (MAX_VIDEOS - videoUploadCount <= 0) {
      videoUploadButton.prop('disabled', true)
      videoUploadButton.addClass('disabled')
    }
  }

  $(document.body).on('click', '.photo img', function () {
    $(this).parent().find('.edit-photo').click()
  })

  //edit image
  $(document.body).on('click', '.edit-photo', function () {
    $('#croppie_container').empty()
    var imgTag = $(this).parent().find('img')
    var imageData = $(this).parent().data('photo') ? $(this).parent().data('photo') : []
    var url = $(this).data('url-path')
    var el = document.getElementById('croppie_container')
    var rotate = imageData.transformation ? imageData.transformation.a : 0
    var boundary = $(window).width() < 484 ? $(window).width() - 100 : 400
    var points = []
    var p

    var crop = new Croppie(el, {
      viewport: { width: 247, height: 247 },
      boundary: { width: boundary, height: boundary },
      showZoomer: true,
      enableOrientation: true,
    })

    if (imageData.transformation && imageData.transformation.w === 400) {
      points = [
        imageData.transformation.x * 1.595,
        imageData.transformation.y * 1.595,
        imageData.transformation.x2 * 1.595,
        imageData.transformation.y2 * 1.595,
      ]
    } else if (imageData.transformation) {
      points = [
        imageData.transformation.x,
        imageData.transformation.y,
        imageData.transformation.x2,
        imageData.transformation.y2,
      ]
    }

    if (imageData.transformation) {
      let imageOrientation = 1
      if (imageData.transformation.a === 90) {
        imageOrientation = 6
      } else if (imageData.transformation.a === 180) {
        imageOrientation = 3
      } else if (imageData.transformation.a === 270) {
        imageOrientation = 8
      }

      p = crop.bind({
        url: url,
        points: points,
        zoom: imageData.transformation ? imageData.transformation.z : 1,
        orientation: imageOrientation,
      })
    } else {
      p = crop.bind({
        url: url,
        points: points,
        zoom: imageData.transformation ? imageData.transformation.z : 1,
        enableExif: true,
      })
    }

    p.then(function () {
      $('.loader').hide()
    })

    $('.cr-slider-wrap').append('<p>Zoom <i class="fa fa-search-plus" aria-hidden="true"></i></p>')

    $('.rotate').click(function () {
      crop.rotate(90)
      rotate = rotate != 360 ? rotate + 90 : (rotate = 90)
    })

    $('.edit_modal .save')
      .unbind()
      .click(function () {
        crop.result('html').then(function (data) {
          $('.edit_result').append(data)
          var d = crop.get()

          setTimeout(function () {
            var l =
              $('.edit_result img').height() > $('.edit_result img').width()
                ? $('.edit_result img').height()
                : $('.edit_result img').width()
            var x = d.points[0]
            var y = d.points[1]
            var x2 = d.points[2]
            var y2 = d.points[3]
            var a = rotate
            var z = d.zoom

            if (!$('.edit_result img').height() || !$('.edit_result img').width()) {
              $('#croppie_container p').empty()
              $('#croppie_container').append('<p class="error">Error occured while saving.</p>')
            }

            $.ajax({
              url: imageData.id,
              type: 'PUT',
              data: { transformation: JSON.stringify({ x, y, a, w: l, h: l, z, x2, y2 }) },
              success: function (result) {
                imgTag.attr('src', result[1])
                imageData.transformation = { x, y, a, w: l, h: l, z, x2, y2 }
                imgTag.closest('.photo').attr('data-photo', JSON.stringify(imageData))
                $(`.edit_modal ${CLOSE_BUTTON_SELECTOR}`).click()
                $('.edit_result').empty()
                $('.loader').show()
              },
              error: function () {
                $('#croppie_container p').empty()
                $('#croppie_container').append('<p class="error">Error occured while saving.</p>')
              },
            })
          }, 1000)
        })
      })
  })

  createSortable('sortablePhotos')
  createSortable('sortableVideos')

  function uploadAndDisplay(photo) {
    var formData = new FormData()
    var url = photo.secure_url.split('upload/')
    var squaredUrl = url.join('upload/fl_lossy/')

    formData.append('secure_url', photo.secure_url)
    formData.append('public_id', photo.public_id)
    formData.append('resource_type', photo.resource_type)
    formData.append('order', $('.photo').length)

    $.ajax({
      url: 'create',
      type: 'POST',
      data: formData,
      processData: false,
      contentType: false,
      success: function (photoResults) {
        if (photo.resource_type === 'image') {
          const image = $('<img />', {
            src: url.join('upload/h_200,w_200,c_fill,g_face,f_auto,q_auto:eco/'),
            class: 'c-listing-photo-uploader__thumbnail-img',
            alt: 'listing photo',
          })

          //get placeholder to replace
          let $placeholder = $('.js-c-listing-photo-uploader-placeholder')
          $placeholder[0].remove()

          if ($('.js-c-listing-photo-uploader__thumbnail').length > 0) {
            $('.js-c-listing-photo-uploader__thumbnail')
              .last()
              .after(
                $('<li>', {
                  class: 'c-listing-photo-uploader__thumbnail js-c-listing-photo-uploader__thumbnail',
                  id: photo.public_id,
                  data: {
                    photo: {
                      id: photoResults.id,
                      transformation: '',
                      original_image_path: url,
                    },
                  },
                })
              )
          } else {
            $('.js-c-listing-photo-uploader__list').prepend(
              $('<li>', {
                class: 'c-listing-photo-uploader__thumbnail js-c-listing-photo-uploader__thumbnail',
                id: photo.public_id,
                data: {
                  photo: {
                    id: photoResults.id,
                    transformation: '',
                    original_image_path: url,
                  },
                },
              })
            )
          }

          $('#' + photo.public_id).append(image)
          $('<a />', {
            class: 'action edit-photo',
            text: 'Edit',
            href: '',
            rel: 'nofollow',
            'data-action': 'open-modal',
            'data-modal': 'edit_modal',
            'data-url-path': squaredUrl,
          }).appendTo('#' + photo.public_id)

          $('<a />', {
            class: 'action remove-photo',
            html: '<i class="fa fa-trash"></i>',
            href: photoResults.id,
            rel: 'nofollow',
            'data-method': 'delete',
            'data-confirm': 'Are you sure you want to delete this photo?',
          }).appendTo('#' + photo.public_id)

          photoUploadCount = $('.js-c-listing-photo-uploader__thumbnail').length
          updatePhotoUIState(photoUploadCount)
        }
        if (photo.resource_type === 'video') {
          let videoImage = url.join('upload/w_200,h_200,c_fill/')
          videoImage = videoImage.replace(/\.[^/.]+$/, '')
          const image = $('<img />', {
            src: videoImage + '.jpg',
            class: 'c-listing-photo-uploader__thumbnail-img',
            alt: 'listing photo',
          })

          //get placeholder to replace
          let $placeholder = $('.js-c-listing-video-uploader-placeholder')
          $placeholder[0].remove()

          if ($('.js-c-listing-video-uploader__thumbnail').length > 0) {
            $('.js-c-listing-video-uploader__thumbnail')
              .last()
              .after(
                '<li class="c-listing-photo-uploader__thumbnail js-c-listing-video-uploader__thumbnail" id="' +
                  photo.public_id +
                  '"></li>'
              )
          } else {
            $('.js-c-listing-video-uploader__list').prepend(
              '<li class="c-listing-photo-uploader__thumbnail js-c-listing-video-uploader__thumbnail" id="' +
                photo.public_id +
                '"></li>'
            )
          }
          $('#' + photo.public_id).append('<div class="overlay video_uploader"></div>')
          $('#' + photo.public_id).append(image)

          $('<a />', {
            class: 'action remove-photo',
            html: '<i class="fa fa-trash"></i>',
            href: photoResults.id,
            rel: 'nofollow',
            'data-method': 'delete',
            'data-confirm': 'Are you sure you want to delete this video?',
          }).appendTo('#' + photo.public_id)

          videoUploadCount = $('.js-c-listing-video-uploader__thumbnail').length
          updateVideoUIState(videoUploadCount)
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.reload()
        }
      },
    })
  }
}

function createSortable(sortableId) {
  const sortableEl = document.getElementById(sortableId)
  if (!sortableEl) return

  Sortable.create(sortableEl, {
    scroll: false,
    onUpdate: function () {
      const order = Array()
      $(`#${sortableId} .js-c-listing-photo-uploader__thumbnail`).each(function () {
        if ($(this).hasClass('js-c-listing-video-uploader-placeholder')) return
        const dataPhoto = $(this).data('photo')
        order.push(dataPhoto.id)
      })
      if (order.length) {
        $.ajax({ url: 'order_images', type: 'PUT', data: { order } })
      }
    },
  })
}
